import axios from 'axios';
import { BACKEND_URL } from './api.service';
import keycloak from '../keycloak';
import { startOfToday } from 'date-fns';

const API_URL = BACKEND_URL + '/api';

axios.interceptors.request.use(
  async (config) => {
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getLaboratori = async () => {
  try {
    //const response = await axios.get(`${API_URL}/laboratoris?populate[0]=immagine&populate[1]=esperimentis.immagine&populate[2]=esperimentis.disponibilita`);
    const response = await axios.get(`${API_URL}/laboratoris`);
    return response.data;
  } catch (error) {
    console.error('Error fetching laboratori:', error);
    throw error;
  }
};

export const getPrenotazioni = async () => {
  try {
    const response = await axios.get(`${API_URL}/prenotazionis`);
    return response.data;
  } catch (error) {
    console.error('Error fetching prenotazioni:', error);
    throw error;
  }
};

export const createPrenotazione = async (data, slots, espId) => {
  const body = {
    data: {
      data, slots, esperimenti: espId
    }
  }
  try {
    const response = await axios.post(`${API_URL}/prenotazionis`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error creating prenotazione:', error);
    throw error;
  }
};

export const deletePrenotazione = async (documentId) => {
  try {
    const response = await axios.delete(`${API_URL}/prenotazionis/${documentId}`);
    return response;
  } catch (error) {
    console.error('Error deleting prenotazione:', error);
    throw error;
  }
};

export const updatePrenotazione = async (documentId, newstate) => {
  const body = {
    documentId,
    data: {
      stato: newstate

    }
  } 
  console.log('updatePrenotazione', body);

  try {
    const response = await axios.put(`${API_URL}/prenotazionis/${documentId}`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error updating prenotazione:', error);
    throw error;
  }
};

export const getLaboratorioUtente = async () => {
  try {
    const response = await axios.get(`${API_URL}/laboratoris/utente`);
    return response.data;
  } catch (error) {
    console.error('Error fetching laboratori:', error);
    throw error;
  }
};

export const updateLaboratorio = async (documentId, obj) => {
  const body = {
    documentId,
    data: {
      ...obj
    }
  }
  console.log('updateLaboratorio', body);
  try {
    const response = await axios.put(`${API_URL}/laboratoris/${documentId}`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error updating laboratorio:', error);
    throw error;
  }
};

export const uploadFile = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/upload`, formData);
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
}

export const updateEsperimento = async (documentId, obj) => {
  const body = {
    documentId,
    data: {
      ...obj
    }
  }
  try {
    const response = await axios.put(`${API_URL}/esperimentis/${documentId}`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error updating esperimento:', error);
    throw error;
  }
};

export const createEsperimento = async (obj) => {
  const body = {
    data: {
      ...obj
    }
  }
  try {
    const response = await axios.post(`${API_URL}/esperimentis`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error creating esperimento:', error);
    throw error;
  }
};

export const deleteEsperimento = async (documentId) => {
  try {
    const response = await axios.delete(`${API_URL}/esperimentis/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting esperimento:', error);
    throw error;
  }
}

export const deleteDisponibilita = async (documentId) => {
  try {
    const response = await axios.delete(`${API_URL}/disponibilitas/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting disponibilita:', error);
    throw error;
  }
}

export const updateTimeSlots = async (documentId, obj) => {
  const body = {
    documentId,
    data: {
      ...obj
    }
  }
  try {
    const response = await axios.put(`${API_URL}/disponibilitas/${documentId}`, body);
    return response.data.data;
  } catch (error) {
    console.error('Error updating esperimento:', error);
    throw error;
  }
};